// extracted by mini-css-extract-plugin
export default {"form":"DefaultFormCard_form__P6RJY","content":"DefaultFormCard_content__niIuN","communityContent":"DefaultFormCard_communityContent__+JOgh"};